var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "#current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_35613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C6.8187 14 6.64482 13.928 6.51663 13.7998C6.38843 13.6716 6.31641 13.4977 6.31641 13.3164V0.683594C6.31641 0.502293 6.38843 0.328419 6.51663 0.20022C6.64482 0.0720213 6.8187 0 7 0C7.1813 0 7.35518 0.0720213 7.48337 0.20022C7.61157 0.328419 7.68359 0.502293 7.68359 0.683594V13.3164C7.68359 13.4977 7.61157 13.6716 7.48337 13.7998C7.35518 13.928 7.1813 14 7 14Z",
    fill: "#current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3164 7.67969H0.683594C0.502293 7.67969 0.328419 7.60767 0.20022 7.47947C0.0720213 7.35127 0 7.17739 0 6.99609C0 6.81479 0.0720213 6.64092 0.20022 6.51272C0.328419 6.38452 0.502293 6.3125 0.683594 6.3125H13.3164C13.4977 6.3125 13.6716 6.38452 13.7998 6.51272C13.928 6.64092 14 6.81479 14 6.99609C14 7.17739 13.928 7.35127 13.7998 7.47947C13.6716 7.60767 13.4977 7.67969 13.3164 7.67969Z",
    fill: "#current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_35613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddField);
export default __webpack_public_path__ + "static/media/AddField.75f11939a5e53c28c367c05da0d2ef13.svg";
export { ForwardRef as ReactComponent };